import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderSubmitButton } from '../common/form';
import * as Validations from '../common/form/commonValidations';

const DifferentStoreForm = ({ handleSubmit, pristine, submitting, valid }) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="externalStoreName"
      type="text"
      id="store-name"
      component={RenderField}
      validate={[Validations.REQUIRED]}
      placeholder="Store Name"
      required
    />
    <Field
      name="orderNumber"
      type="text"
      id="order-number"
      component={RenderField}
      placeholder="Order Number (optional)"
    />
    <Field
      name="giftGiverName"
      type="text"
      id="gift-giver-name"
      component={RenderField}
      validate={[Validations.REQUIRED]}
      required
      placeholder="Your First and Last Name"
    />
    <Field
      name="giftGiverEmail"
      type="email"
      id="gift-giver-email"
      component={RenderField}
      validate={[Validations.REQUIRED, Validations.EMAIL]}
      required
      placeholder="Your email"
    />

    {/* product actions */}
    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} className="btn btn-primary btn-wide" value="finish" />
    </div>
  </form>
);


DifferentStoreForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  initialValues: {
    externalStoreName: state.external.externalStoreName,
    giftGiverName: state.external.giftGiverName,
    giftGiverEmail: state.external.giftGiverEmail
  }
});

export default connect(
  mapStateToProps
)(reduxForm({
  form: 'DifferentStoreForm'
})(DifferentStoreForm));



// WEBPACK FOOTER //
// ./src/components/registryitem/DifferentStoreForm.jsx